import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../../features/ui"
import { PurchaseList } from "./purchaseList"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { PurchaseOrder } from "../../../state/types"
import { usePurchaseLoaders } from "../../../loaders/purchaseLoaders"
import { useManagerState } from "../../../../manager"
import { define } from "../../../../../utils/typeUtils"
import { Ticket, useTicketLoaders } from "../../../../administration"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"

export const Loader = () => {
    const { currentBranch } = useManagerState()
    const branchId = define(currentBranch).id

    const [purchases, setPurchases] = useState<PurchaseOrder[]>([])
    const [tickets, setTickets] = useState<Ticket[]>([])
    const [ready, setReady] = useState(false)

    const purchaseLoaders = usePurchaseLoaders()
    const ticketLoaders = useTicketLoaders()

    const populate = async () => {
        const { loadBranchPurchases } = purchaseLoaders()
        const loadedPurchases = await loadBranchPurchases(branchId)
        const activePurchases = loadedPurchases.filter(purchase => !purchase.archived)
        setPurchases(activePurchases)
        const purchaseIds = activePurchases.map(purchase => purchase.id)
        const { loadTicketsByParents } = ticketLoaders()
        setTickets(await loadTicketsByParents(purchaseIds))
    }

    useEffect(() => {
        setReady(false)
        populate().then(() => setReady(true))
    }, [branchId])

    return (
        <PanelLoader
            title="Órdenes de Compra"
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.PURCHASES} />}
        >
            <PurchaseList
                purchases={purchases}
                tickets={tickets}
            />
        </PanelLoader>
    )
}

export const PurchaseListLoader = () => (
    <ListLoaderWrapper table={TableName.PURCHASE_ORDERS}>
        <Loader />
    </ListLoaderWrapper>
)
